/* * @Author: knight * @Title: 排行榜组件 * @Date: 2020-04-07 16:55:57 * @Last
Modified by: knight * @Last Modified time: 2020-05-27 15:33:16 */
<template>
  <div class="rank" ref="rank">
    <dl>
      <dt class="title">{{ data.title || "热销排行榜" }}</dt>
      <dd v-for="(list, index) in data.items" :key="index">
        <a
          :href="`${list.link}?spm_id_from=${SPM_ID_FROM_RANK}`  | hostAdapt | csourceTransmit"
          target="_blank"
          v-href
          class="list"
          v-reportShow="{
            data: { ssid: list.oid },
            module: 'hot_sellings'
          }"
          v-report="{
            data: { ssid: list.oid },
            module: 'hot_sellings'
          }"
        >
          <div :class="['rank-index', index <= 2 ? 'hot' : '']">
            {{ index + 1 }}
          </div>
          <div class="img">
            <BilibiliImg :src="list.cover" :width="112" :height="63" cut />
          </div>
          <div class="content">
            <h5 class="rank-title">{{ list.title }}</h5>
            <p class="rank-updateInfo ell">{{ list.update_info }}</p>
            <!-- <p>{{ list.progress | lastWatchInfo }}</p> -->
          </div>
        </a>
      </dd>
    </dl>
  </div>
</template>
<script>
import BilibiliImg from 'g-public/components/CommonLazyImg'
import { SPM_ID_FROM_RANK } from '../enum'

export default {
  components: {
    BilibiliImg,
  },

  props: {
    data: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      unbindShow: null,
      SPM_ID_FROM_RANK,
    }
  },

  mounted() {},

  // filters: {
  //     lastWatchInfo(progress) {
  //         if (!progress) return '';
  //         let str = `上次观看第${progress.last_ep_index}集 ${progress.last_time}`;

  //         return str;
  //     }
  // },

  methods: {
  },
}
</script>
<style lang="less" scoped>
.title {
  font-size: 20px;
  color: #212121;
  line-height: 28px;
  margin-bottom: 20px;
}

.list {
  display: flex;
  margin-bottom: 25px;

  &:hover {
    .rank-title {
      color: #0ba395;
    }
  }
}

.rank-index {
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  color: #fff;
  background: #ccc;
  border-radius: 2px;
  margin-right: 10px;

  &.hot {
    background: #0ba395;
  }
}

.img {
  width: 112px;
  height: 63px;
  margin-right: 12px;
  border-radius: 4px;
}

.rank-title {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  width: 260px;
  color: #212121;
  max-height: 40px;
  overflow: hidden;
  word-break: break-all;
  /* display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    white-space: normal; */
}

.rank-updateInfo {
  font-size: 12px;
  color: #999999;
  letter-spacing: 0;
  line-height: 20px;
  position: absolute;
  left: 0;
  bottom: 0;
}

.rank {
  padding-top: 20px;
}

.content {
  position: relative;
}
</style>
